<template>
    <b-container>
        <h1 class="text-center pt-4 pb-4">{{ $t("title.report") }}</h1>

        <b-row>
            <b-col sm="4" class="mt-4">
                <b-form-select v-model="report" :options="reportType"></b-form-select>
            </b-col>
        </b-row>

        <b-row v-if="report">
            <b-col sm="4" class="mt-4">
                <datepicker input-class="datepicker" v-model="month" :placeholder="$t('action.chooseDate')"
                    :language="language" :minimumView="'month'" :maximumView="'month'" :disabledDates="disabledMonth">
                </datepicker>
            </b-col>
        </b-row>

        <b-row v-if="taskList.length > 0" class="pt-2">
            <b-col sm="6" class="mt-2">
                <ExcelReport :data="getAutotableBody()" fileName="Task.xlsx" worksheet="Task"
                    :range="getRange()" />
            </b-col>
        </b-row>

        <b-row v-if="noTaskForThisPeriod" class="pt-2">
            <b-col sm="6" class="mt-2">
                <b-alert show variant="info">
                    <p>{{ $t('info.noTaskForThisPeriod') }}</p>
                </b-alert>
            </b-col>
        </b-row>


        <b-row v-if="error" class="text-center pt-4">
            <b-col>
                <b-alert show variant="danger">
                    <p>{{ error }}</p>
                </b-alert>
            </b-col>
        </b-row>

        <div v-if="spinner">
            <b-spinner style="width: 3rem; height: 3rem" class="spinner" variant="success" label="Spinning"
                disabled="labelStatus"></b-spinner>
        </div>
    </b-container>
</template>
  
<script>
import ExcelReport from "./ExcelReport.vue";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import moment from "moment";
import { globalF } from "../../Helpers";
import { required } from 'vuelidate/lib/validators';

export default {
    mixins: [globalF],
    data() {
        return {
            month: "",
            firstDate: "",
            secondDate: "",
            taskList: [],
            report: null,
            spinner: false,
            success: false,
            disabled: false,
            error: "",
            info: "",
            noTaskForThisPeriod: false
        };
    },
    validations() {
        return {
            month: {
                required
            }
        }
    },
    mounted() {},
    computed: {
        url: function () {
            return this.getUrl();
        },
        user: function () {
            return this.$store.getters.getUser;
        },
        reportType: function () {
            return [
                {
                    value: null,
                    text: this.$t("action.chooseReportType")
                },
                {
                    value: "task",
                    text: this.$t("label.task")
                }
            ]
        },
        language: function () {
            return this.$i18n.locale === "fr" ? fr : en;
        },
        disabledMonth: function () {
            return { from: moment().toDate() };
        },
        disabledDates: function () {
            let myDate = moment().endOf('day').toDate();
            let sixMonth = moment().subtract(6, 'months').toDate();
            return { to: sixMonth, from: myDate };
        },
        disabledFirstDate: function () {
            let sixMonth = moment().subtract(6, 'months').toDate();
            let today = moment().endOf('day').toDate();
            return { from: today, to: sixMonth };
        },
        disabledSecondDate: function () {
            let today = moment().endOf('day').toDate();
            let myDate = this.getMinDateForDatePicker();
            return { from: today, to: myDate };
        }
    },
    watch: {
        month: function (newDate) {
            this.error = "";
            this.spinner = false;
            this.success = false;
            this.taskList = [];
            this.noTaskForThisPeriod = false;
            this.getTaskList(newDate);
        },
    },
    methods: {
        getMinDateForDatePicker() {
            let min = moment().subtract(6, 'months').toDate();
            if (moment(this.firstDate).isValid()) {
                min = moment(this.firstDate).startOf('day').toDate();
            }
            return min;
        },
        getSecondDate: function () {
            return moment().subtract(6, 'months').toDate();
        },
        getTaskList(newDate) {
            
            this.error = "";
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.spinner = true;
                let firstDate = moment(newDate).format("YYYY-MM-DD");
                let secondDate = moment(newDate).add(1, 'month').format("YYYY-MM-DD");

                axios
                    .post(
                        this.url,
                        {
                            request: "getTaskEventBetweenDate",
                            firstDate: firstDate,
                            secondDate: secondDate
                        },
                        { headers: { "Content-Type": "application/json" } }
                    )
                    .then((response) => {
                        this.setTaskList(response.data);

                        this.disabled = false;
                        this.spinner = false;
                    })
                    .catch((error) => {
                        this.error = error;
                        this.disabled = false;
                        this.spinner = false;
                    });
            }
        },
        setTaskList(taskList) {
            if (taskList) {
                let jobResult = JSON.parse(taskList.JobResult);
                if (jobResult.length > 0) {
                    //Group task by building
                    let buildingTaskList = [];
                    for (let i = 0; i < jobResult.length; i ++) {
                        let task = jobResult[i];
                        let taskBuilding = {
                            BuildingId: 0,
                            NOMDIV: "",
                            taskList: []
                        };

                        let index = buildingTaskList.findIndex(b => b.BuildingId === task.BuildingId);

                        if (index === -1) {
                            taskBuilding.BuildingId = task.BuildingId;
                            taskBuilding.NOMDIV = task.NOMDIV;
                            taskBuilding.taskList.push(task);

                            buildingTaskList.push(taskBuilding);
                        }
                        else {
                            buildingTaskList[index].taskList.push(task);
                        }
                    }

                    this.taskList = buildingTaskList;
                }
                else {
                    this.noTaskForThisPeriod = true;
                }
            }
            else {
                this.noTaskForThisPeriod = true;
            }
        },
        getAutotableBody: function () {
            let all = [];
            let data = this.taskList;
            let header = [
                "Title",
                "Creation",
                "CompletedBy",
                "CompletedDateTime"
            ]
            
            all.push(header);
            all.push(["", "", "", ""]);

            for (let i = 0; i < data.length; i++) {
                let buildingHeader = [];
                buildingHeader.push(
                    data[i].NOMDIV,
                    "",
                    "",
                    ""
                );

                all.push(buildingHeader);
                all.push(["", "", "", ""]);

                let taskList = data[i].taskList;

                for (let j = 0; j < taskList.length; j++) {
                    let buildingTask = [];
                    let task = taskList[j];
                    let CompletedBy = this.getCompletedBy(task.CompletedBy);
                    let CompletedDateTime = this.getCompletedDateTime(task.CompletedDateTime);
                    let Creation = task.Creation ? moment(task.Creation).format("YYYY-MM-DD HH:mm:ss") : "";
                    buildingTask.push(
                        task.Title,
                        Creation,
                        CompletedBy,
                        CompletedDateTime
                    );
                    all.push(buildingTask);
                }

                all.push(["", "", "", ""]);
            }

            return all;
        },
        getCompletedBy: function (value) {
            return value.length === 0 ? "" : value.displayName;
        },
        getCompletedDateTime: function (value) {
            return value ? moment(value.date).format("YYYY-MM-DD HH:mm:ss") : "";
        },
        getRange: function () {
            //De A à Z correspond au nombre de champs dans l'entête (nom, courriel, consent, etc.).
            let excelList = this.getAutotableBody();
            return "A1:D" + excelList.length;
        },
    },
    components: {
        ExcelReport,
        Datepicker
    },
};
</script>
  